module.exports = __webpack_public_path__ + "media/we-are-one-vexento-no-copyright-music.ce431d09.mp3";